<template>
    <div>
        <el-breadcrumb separator="/" class="bread">
            <el-breadcrumb-item>applet订单详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div >
            <div >
                <el-table :data="tableRefData" ref="tradeTable">
                    <el-table-column label="申请记录" >
                        <el-table-column  prop="userName" label="联系人" >
                        </el-table-column>
                        <el-table-column prop="phone" label="手机">
                        </el-table-column>
                        <el-table-column label="申请原因" prop="refreason">
                        </el-table-column>
                    </el-table-column>
                </el-table>
            </div>
            <div >
                <el-table :data="tableDataRef" ref="tradeTable">
                    <el-table-column label="退款申请" >
                        <el-table-column  prop="payTotal" label="可退金额" >
                            <template slot-scope="scope">
                                <div>￥{{(scope.row.payTotal - scope.row.refTotal) / 100 }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="退款金额">
                            <template slot-scope="scope">
                                <el-input v-model="okRefPrice" style="width: 100px;"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="备注">
                            <template slot-scope="scope">
                                <el-input v-model="remark" style="width: 80%;"></el-input>
                            </template>
                        </el-table-column>
                    </el-table-column>
                </el-table>
            </div>
            <div style="margin-top: 20px;margin-left: 150px;">
                <span style="font-weight:bold;width:250px;">退款金额：{{okRefPrice}}</span>
                <el-button style="margin-left: 50px;" type="primary" @click="refProduct()"
                           :disabled="this.$route.query.payStatus =='ok' && this.$route.query.refStatus != '4' || this.refFlag "
                >确认退款</el-button>
                <el-button style="margin-left: 50px;" @click="getBack()">返回</el-button>
            </div>
        </div>
        <div style="margin-top: 20px;">
            <p style="font-weight:bold;width:200px;">订单号： {{orderId}}</p>
            <el-table :data="tableDataPro"  ref="tradeTable">
                <el-table-column label="商品出货明细" >
                    <el-table-column  prop="productName" label="商品名称"></el-table-column>
                    <el-table-column prop="count" label="数量" > </el-table-column>
                    <el-table-column  prop="proPayTotal" label="实付金额" >
                        <template slot-scope="scope">
                            <div>￥{{scope.row.proPayTotal / 100}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="proStatus" label="商品状态" >
                        <template scope="scope">
                            <div v-if="scope.row.proStatus == ''">
                                <div >未出货</div>
                            </div>
                            <div v-if="scope.row.proStatus != ''">
                                <div >{{scope.row.proStatus}}</div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>
        <div style="margin-top: 20px;">
            <el-table :data="tableData"  ref="tradeTable">
                <el-table-column label="退款记录" >
                    <el-table-column  prop="wechat_refund_id" label="退款流水号"></el-table-column>
                    <el-table-column prop="refund_time" label="申请时间" :formatter="updateformatter"> </el-table-column>
                    <el-table-column prop="total_fee" label="退款金额" >
                        <template slot-scope="scope">
                            <div>￥{{scope.row.total_fee / 100}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="refund_status" label="状态" >
                        <template slot-scope="scope">
                            <div v-if="scope.row.refund_status=='0'">未退款</div>
                            <div v-else-if="scope.row.refund_status=='1'">已退款</div>
                            <div v-else-if="scope.row.orderStatus==''">退款失败</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="operator" label="操作人" ></el-table-column>
                    <el-table-column prop="remark" label="备注"></el-table-column>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
    import moment  from 'moment'
    import ElButton from "../../../../node_modules/element-ui/packages/button/src/button.vue";
    import ElInput from "../../../../node_modules/element-ui/packages/input/src/input.vue";

    export default {
        components: {
            ElInput,
            ElButton},
        data() {
            return {
                url: this.productURL+"/vueFeign/findOrderRef",
                refapplyurl: this.productURL+"/vueFeign/findRefApply",
                //参数设置
                refurl: this.productURL+"/vueFeign/refWechat",
                tableDataRef: [
                    {
                        refPrice:'',
                    }
                ],
                refFlag:true,
                tableData: [],
                tableRefData: [],
                tableDataPro:[],
                okRefPrice:'',
                remark:'',
                orderId:'',
                orderNo:'',
                proPayTotal:'',
                kioskNo:'',
                datatime:[],
            }
        },
        created(){
            this.orderId = this.$route.query.orderId;
            this.orderNo = this.$route.query.orderNo;
            this.kioskNo = this.$route.query.kioskNo;
            this.datatime = this.$route.query.datatime;
            console.log(this.datatime)
            this.tableDataPro = this.$route.query.orderPro;
            this.getData();
            this.getRefApplyInfo();

        },
        methods: {
            sumPrice(){
                var price = 0;
                for(var i=0;i<this.tableDataPro.length;i++){
                    if(this.tableDataPro[i].proStatus == '' || this.tableDataPro[i].proStatus == '出货失败'){
                        price = price + this.tableDataPro[i].proPayTotal;
                    }

                }
                if(price != 0 &&  (this.tableDataRef[0].payTotal - this.tableDataRef[0].refTotal) / 100 == 0 ){
                    this.refFlag = true;
                    this.okRefPrice=0;
                }else {
                    this.refFlag = false;
                    if(this.tableData.length > 0){
                        this.okRefPrice= (price - this.tableData[0].total_fee) /100 < 0 ? 0 :this.okRefPrice= (price - this.tableData[0].total_fee) /100;
                    }else {
                        this.okRefPrice= price  /100 < 0 ? 0 :this.okRefPrice= price /100;
                    }

                }

                console.log(price)
            },
            getData(){
                var params = {orderNo:this.orderId};
                //异步请求
                this.$http.post(this.url,params)
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                this.tableData = response.body.Data.List;
                                this.tableDataRef = response.body.Data.listSum;
                                this.sumPrice();
                            }else{
                                this.$message({ showClose: true, message: response.body.Meta,  type: 'error' });
                            }
                        }
                    },function(response){
                        this.putawayProductVisible = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            getRefApplyInfo(){
                var params = {orderNo:this.orderId};
                //异步请求
                this.$http.post(this.refapplyurl,params)
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                this.tableRefData = response.body.Data.List;
                            }else{
                                this.$message({ showClose: true, message: response.body.Meta,  type: 'error' });
                            }
                        }
                    },function(response){
                        this.putawayProductVisible = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            refProduct(){
                this.$confirm('你确定要退款吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.refFlag = true;
                    var okprice = (this.okRefPrice * 100);
                    var total = (this.tableDataRef[0].payTotal - this.tableDataRef[0].refTotal)
                    if (okprice <= total) {
                        var params = {
                            refPrice: this.okRefPrice * 100, orderNo: this.orderId,
                            userName: this.getcookie('username_client'), remark: this.remark
                        };
                        //异步请求
                        this.$http.post(this.refurl, params)
                            .then(response => {
                                if (response.status === 200) {
                                    if (response.body.Code == '200') {
                                        this.$message({showClose: true, message: response.body.Meta, type: 'success'});
                                    } else {
                                        this.$message({showClose: true, message: response.body.Meta, type: 'error'});
                                    }
                                }
                                this.getData();
                            }, function (response) {
                                this.putawayProductVisible = false;
                                this.$message({
                                    showClose: true,
                                    message: '网络异常',
                                    type: 'error'

                                });
                            })

                    } else {
                        this.$message({showClose: true, message: '大于可退金额', type: 'error'});
                    }
                })
            },
            updateformatter(row, column) {
                console.log()
                var d = new Date(row.refund_time.time)
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },
            getBack(){
                this.$router.push( {path:"appletOrderManager",query:{
                        orderNo:this.orderNo,
                        kioskNo:this.kioskNo,
                        datatime:this.datatime
                    }
                });
            }
        },
    }
</script>


// WEBPACK FOOTER //
// orderRef.vue?7a1a2bd1